module.exports = __webpack_public_path__ + "static/media/class_01.e0c6b05a.jpg";